import { useContext } from 'react';

import { SiteChromeDynamicContext } from './SiteChromeDynamicContext';

export const useSiteChromeDynamicContext = () => {
  const context = useContext(SiteChromeDynamicContext);

  if (context === undefined) {
    throw new Error(
      'useSiteChromeDynamicContext must be used within a SiteChromeDynamicContextProvider',
    );
  }

  return context;
};
